import React from 'react';

const Dashboard: React.FC = () => {
  return (
    <div>
      <h1>Welcome to the Partner Portal</h1>
      <p>Use the navigation on the left to manage your cases or referrals.</p>
    </div>
  );
};

export default Dashboard;
